(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6240],{

/***/ 73491:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-condition",
      function () {
        return __webpack_require__(85009);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 85009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47046);
/* harmony import */ var _styles_Header_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71726);
/* harmony import */ var _styles_Header_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Header_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const TermsAndConditions = (props)=>{
    const { meta  } = props.pageData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#226CF5");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_2__/* .MetaTagsComp */ .r, {
                ...meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_Header_module_scss__WEBPACK_IMPORTED_MODULE_3___default().termsClass),
                dangerouslySetInnerHTML: {
                    __html: props.pageData.description
                }
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (TermsAndConditions);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(73491); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);